import { render, staticRenderFns } from "./ApdBalance.vue?vue&type=template&id=70d7806b&scoped=true&"
import script from "./ApdBalance.vue?vue&type=script&lang=js&"
export * from "./ApdBalance.vue?vue&type=script&lang=js&"
import style0 from "./ApdBalance.vue?vue&type=style&index=0&id=70d7806b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7806b",
  null
  
)

export default component.exports